// extracted by mini-css-extract-plugin
export default {"itemContainer":"TimelineItem_itemContainer__LRcvl","title":"TimelineItem_title__4QYKw","eventDesc":"TimelineItem_eventDesc__UQQsD","eventTimes":"TimelineItem_eventTimes__UdvNV"};